export default class WebSocketEvent extends Event {
  public static WS_TOAST:string = 'wsToastMessage'
  public static WS_CONFIRM:string = 'wsConfirmMessage'
  public static WS_CONFIRM_CUSTOM:string = 'wsConfirmCustomMessage'
  public static WS_DISCONNECTED:string = 'wsDisconnected'
  public static WS_EVENT:string = 'wsEvent'
  
  public payload:any = {}
}